import { graphql } from '@api/generated';

export const getUsersAvailabilityActivityQuery = graphql(`
  query getUsersAvailabilityActivityQuery($skipStats: Boolean = true) {
    users {
      items {
        id
        contactCenterUserId
        name
        email
        availabilityActivityStatus @skip(if: $skipStats) {
          availabilityStatus
          activityStatus
        }
        stats @skip(if: $skipStats) {
          lastActionAt
          lastHandledAt
          lastIdleAt
          loginAt
          totalSessions
          offeredSessions
          missedSessions
          avgCallTime
        }
        personalLine {
          phoneNumber
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`);
